import { render, staticRenderFns } from "./SwatchTweaker.vue?vue&type=template&id=0feb4bbe&scoped=true&"
import script from "./SwatchTweaker.vue?vue&type=script&lang=ts&"
export * from "./SwatchTweaker.vue?vue&type=script&lang=ts&"
import style0 from "./SwatchTweaker.vue?vue&type=style&index=0&id=0feb4bbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feb4bbe",
  null
  
)

export default component.exports